export const profileDefaults = {
  firstName: '',
  lastName: '',
  optinSms: false,
  optinEmail: false,
  acceptTerms: false,
  attributes: []
}

export const jsonWebTokenDefaults = {
  access_token: '',
  token_type: '',
  expires_in: 0,
  refresh_token: ''
}

export const authDetailsDefaults = {
  code: '',
  customerId: '',
  email: '',
  isRegister: false,
  mobileNumber: '',
  otpType: 0
}
